import { useLocation, useNavigate } from "react-router-dom";
import { BarChart3, Calendar, LayoutDashboard, Sparkles, User } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

const navItems = [
  { key: "dashboard", icon: LayoutDashboard, path: "/coach/dashboard" },
  { key: "schedule", icon: Calendar, path: "/coach/schedule" },
  { key: "trials", icon: Sparkles, path: "/coach/trials" },
  { key: "statistics", icon: BarChart3, path: "/coach/statistics" },
  { key: "profile", icon: User, path: "/coach/profile" },
];

export function CoachBottomNavBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation("coach");

  return (
    <nav className="coach-bottom-nav fixed bottom-0 left-0 right-0 z-50 lg:hidden">
      <div className="absolute inset-0 border-t border-border/50 bg-background/80 backdrop-blur-xl" />

      <div className="relative bg-background">
        <div className="flex h-14 items-center justify-around px-1">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Button
                key={item.key}
                type="button"
                variant="ghost"
                onClick={() => navigate(item.path)}
                className={cn(
                  "h-full flex flex-1 min-w-0 flex-col items-center justify-center gap-0.5 rounded-md px-1.5 py-1 transition-all duration-300",
                  "touch-manipulation select-none",
                  isActive
                    ? "text-primary"
                    : "text-muted-foreground hover:text-foreground"
                )}
                aria-current={isActive ? "page" : undefined}
                aria-label={t(`nav.${item.key}`, item.key)}
              >
                <div
                  className={cn(
                    "relative flex h-6 w-8 items-center justify-center rounded-full transition-all duration-300",
                    isActive && "bg-primary/15"
                  )}
                >
                  <item.icon
                    className={cn(
                      "h-[18px] w-[18px] transition-all duration-300",
                      isActive && "scale-110"
                    )}
                  />
                  {isActive && (
                    <span className="absolute -bottom-0.5 h-1 w-1 rounded-full bg-primary" />
                  )}
                </div>
                <span
                  className={cn(
                    "max-w-[3.5rem] truncate text-center text-[9px] font-medium leading-tight",
                    isActive && "font-semibold"
                  )}
                >
                  {t(`navShort.${item.key}`, item.key)}
                </span>
              </Button>
            );
          })}
        </div>

        <div
          aria-hidden="true"
          className="bg-background"
          style={{ height: "env(safe-area-inset-bottom, 0px)" }}
        />
      </div>
    </nav>
  );
}
